import _regeneratorRuntime from "/Users/challen/code/mace/example/node_modules/@babel/runtime/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/Users/challen/code/mace/example/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "/Users/challen/code/mace/example/node_modules/@babel/runtime/helpers/esm/slicedToArray";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import React, { useState, useEffect, useCallback, useContext } from 'react';
var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function createCommonjsModule(fn, basedir, module) {
  return module = {
    path: basedir,
    exports: {},
    require: function require(path, base) {
      return commonjsRequire(path, base === undefined || base === null ? module.path : base);
    }
  }, fn(module, module.exports), module.exports;
}

function commonjsRequire() {
  throw new Error('Dynamic requires are not currently supported by @rollup/plugin-commonjs');
}

var errors = createCommonjsModule(function (module, exports) {
  var __extends = commonjsGlobal && commonjsGlobal.__extends || function () {
    var _extendStatics = function extendStatics(d, b) {
      _extendStatics = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (d, b) {
        d.__proto__ = b;
      } || function (d, b) {
        for (var p in b) {
          if (b.hasOwnProperty(p)) d[p] = b[p];
        }
      };

      return _extendStatics(d, b);
    };

    return function (d, b) {
      _extendStatics(d, b);

      function __() {
        this.constructor = d;
      }

      d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
  }();

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var ValidationError =
  /** @class */
  function (_super) {
    __extends(ValidationError, _super);

    function ValidationError(message, key) {
      var _this = _super.call(this, key ? message + " in " + key : message) || this;

      _this.key = key;
      _this.name = 'ValidationError';
      Object.setPrototypeOf(_this, ValidationError.prototype);
      return _this;
    }

    return ValidationError;
  }(Error);

  exports.ValidationError = ValidationError;
});
var contract = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  function Contract() {
    var runtypes = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      runtypes[_i] = arguments[_i];
    }

    var lastIndex = runtypes.length - 1;
    var argTypes = runtypes.slice(0, lastIndex);
    var returnType = runtypes[lastIndex];
    return {
      enforce: function enforce(f) {
        return function () {
          var args = [];

          for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
          }

          if (args.length < argTypes.length) throw new errors.ValidationError("Expected " + argTypes.length + " arguments but only received " + args.length);

          for (var i = 0; i < argTypes.length; i++) {
            argTypes[i].check(args[i]);
          }

          return returnType.check(f.apply(void 0, args));
        };
      }
    };
  }

  exports.Contract = Contract;
});
var asynccontract = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  function AsyncContract() {
    var runtypes = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      runtypes[_i] = arguments[_i];
    }

    var lastIndex = runtypes.length - 1;
    var argTypes = runtypes.slice(0, lastIndex);
    var returnType = runtypes[lastIndex];
    return {
      enforce: function enforce(f) {
        return function () {
          var args = [];

          for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
          }

          if (args.length < argTypes.length) throw new errors.ValidationError("Expected " + argTypes.length + " arguments but only received " + args.length);

          for (var i = 0; i < argTypes.length; i++) {
            argTypes[i].check(args[i]);
          }

          var returnedPromise = f.apply(void 0, args);
          if (!(returnedPromise instanceof Promise)) throw new errors.ValidationError("Expected function to return a promise, but instead got " + returnedPromise);
          return returnedPromise.then(returnType.check);
        };
      }
    };
  }

  exports.AsyncContract = AsyncContract;
});
var match_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  function match() {
    var cases = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      cases[_i] = arguments[_i];
    }

    return function (x) {
      for (var _i = 0, cases_1 = cases; _i < cases_1.length; _i++) {
        var _a = cases_1[_i],
            T = _a[0],
            f = _a[1];
        if (T.guard(x)) return f(x);
      }

      throw new Error('No alternatives were matched');
    };
  }

  exports.match = match;
});
var show_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var show = function show(needsParens, circular) {
    return function (refl) {
      var parenthesize = function parenthesize(s) {
        return needsParens ? "(" + s + ")" : s;
      };

      if (circular.has(refl)) {
        return parenthesize("CIRCULAR " + refl.tag);
      }

      circular.add(refl);

      try {
        switch (refl.tag) {
          // Primitive types
          case 'unknown':
          case 'never':
          case 'void':
          case 'boolean':
          case 'number':
          case 'string':
          case 'symbol':
          case 'function':
            return refl.tag;
          // Complex types

          case 'literal':
            {
              var value = refl.value;
              return typeof value === 'string' ? "\"" + value + "\"" : String(value);
            }

          case 'array':
            return "" + readonlyTag(refl) + show(true, circular)(refl.element) + "[]";

          case 'dictionary':
            return "{ [_: " + refl.key + "]: " + show(false, circular)(refl.value) + " }";

          case 'record':
            {
              var keys = Object.keys(refl.fields);
              return keys.length ? "{ " + keys.map(function (k) {
                return "" + readonlyTag(refl) + k + partialTag(refl) + ": " + show(false, circular)(refl.fields[k]) + ";";
              }).join(' ') + " }" : '{}';
            }

          case 'tuple':
            return "[" + refl.components.map(show(false, circular)).join(', ') + "]";

          case 'union':
            return parenthesize("" + refl.alternatives.map(show(true, circular)).join(' | '));

          case 'intersect':
            return parenthesize("" + refl.intersectees.map(show(true, circular)).join(' & '));

          case 'constraint':
            return refl.name || show(needsParens, circular)(refl.underlying);

          case 'instanceof':
            var name_1 = refl.ctor.name;
            return "InstanceOf<" + name_1 + ">";

          case 'brand':
            return show(needsParens, circular)(refl.entity);
        }
      } finally {
        circular.delete(refl);
      }

      throw Error('impossible');
    };
  };

  exports.default = show(false, new Set());

  function partialTag(_a) {
    var isPartial = _a.isPartial;
    return isPartial ? '?' : '';
  }

  function readonlyTag(_a) {
    var isReadonly = _a.isReadonly;
    return isReadonly ? 'readonly ' : '';
  }
});
var runtype = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  function create(validate, A) {
    A.check = check;
    A.assert = check;

    A._innerValidate = function (value, visited) {
      if (visited.has(value, A)) return {
        success: true,
        value: value
      };
      return validate(value, visited);
    };

    A.validate = function (value) {
      return A._innerValidate(value, VisitedState());
    };

    A.guard = guard;
    A.Or = Or;
    A.And = And;
    A.withConstraint = withConstraint;
    A.withGuard = withGuard;
    A.withBrand = withBrand;
    A.reflect = A;

    A.toString = function () {
      return "Runtype<" + show_1.default(A) + ">";
    };

    return A;

    function check(x) {
      var validated = A.validate(x);

      if (validated.success) {
        return validated.value;
      }

      throw new errors.ValidationError(validated.message, validated.key);
    }

    function guard(x) {
      return A.validate(x).success;
    }

    function Or(B) {
      return lib.Union(A, B);
    }

    function And(B) {
      return lib.Intersect(A, B);
    }

    function withConstraint(constraint, options) {
      return lib.Constraint(A, constraint, options);
    }

    function withGuard(guard, options) {
      return lib.Constraint(A, guard, options);
    }

    function withBrand(B) {
      return lib.Brand(B, A);
    }
  }

  exports.create = create;

  function innerValidate(targetType, value, visited) {
    return targetType._innerValidate(value, visited);
  }

  exports.innerValidate = innerValidate;

  function VisitedState() {
    var members = new WeakMap();

    var add = function add(candidate, type) {
      if (candidate === null || !(typeof candidate === 'object')) return;
      var typeSet = members.get(candidate);
      members.set(candidate, typeSet ? typeSet.set(type, true) : new WeakMap().set(type, true));
    };

    var has = function has(candidate, type) {
      var typeSet = members.get(candidate);
      var value = typeSet && typeSet.get(type) || false;
      add(candidate, type);
      return value;
    };

    return {
      has: has
    };
  }
});
var unknown = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  /**
   * Validates anything, but provides no new type information about it.
   */

  exports.Unknown = runtype.create(function (value) {
    return {
      success: true,
      value: value
    };
  }, {
    tag: 'unknown'
  });
});
var never = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  /**
   * Validates nothing (unknown fails).
   */

  exports.Never = runtype.create(function (value) {
    return {
      success: false,
      message: "Expected nothing, but was " + (value === null ? value : typeof value)
    };
  }, {
    tag: 'never'
  });
});

var _void = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  /**
   * Void is an alias for Unknown
   *
   * @deprecated Please use Unknown instead
   */

  exports.Void = unknown.Unknown;
});

var literal_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  /**
   * Be aware of an Array of Symbols `[Symbol()]` which would throw "TypeError: Cannot convert a Symbol value to a string"
   */

  function literal(value) {
    return Array.isArray(value) ? String(value.map(String)) : String(value);
  }
  /**
   * Construct a runtype for a type literal.
   */


  function Literal(valueBase) {
    return runtype.create(function (value) {
      return value === valueBase ? {
        success: true,
        value: value
      } : {
        success: false,
        message: "Expected literal '" + literal(valueBase) + "', but was '" + literal(value) + "'"
      };
    }, {
      tag: 'literal',
      value: valueBase
    });
  }

  exports.Literal = Literal;
  /**
   * An alias for Literal(undefined).
   */

  exports.Undefined = Literal(undefined);
  /**
   * An alias for Literal(null).
   */

  exports.Null = Literal(null);
});
var boolean_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  /**
   * Validates that a value is a boolean.
   */

  exports.Boolean = runtype.create(function (value) {
    return typeof value === 'boolean' ? {
      success: true,
      value: value
    } : {
      success: false,
      message: "Expected boolean, but was " + (value === null ? value : typeof value)
    };
  }, {
    tag: 'boolean'
  });
});
var number = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  /**
   * Validates that a value is a number.
   */

  exports.Number = runtype.create(function (value) {
    return typeof value === 'number' ? {
      success: true,
      value: value
    } : {
      success: false,
      message: "Expected number, but was " + (value === null ? value : typeof value)
    };
  }, {
    tag: 'number'
  });
});
var string = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  /**
   * Validates that a value is a string.
   */

  exports.String = runtype.create(function (value) {
    return typeof value === 'string' ? {
      success: true,
      value: value
    } : {
      success: false,
      message: "Expected string, but was " + (value === null ? value : typeof value)
    };
  }, {
    tag: 'string'
  });
});
var symbol = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  /**
   * Validates that a value is a symbol.
   */

  var Sym = runtype.create(function (value) {
    return typeof value === 'symbol' ? {
      success: true,
      value: value
    } : {
      success: false,
      message: "Expected symbol, but was " + (value === null ? value : typeof value)
    };
  }, {
    tag: 'symbol'
  });
  exports.Symbol = Sym;
});
var array = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  /**
   * Construct an array runtype from a runtype for its elements.
   */

  function InternalArr(element, isReadonly) {
    return withExtraModifierFuncs(runtype.create(function (xs, visited) {
      if (!Array.isArray(xs)) {
        return {
          success: false,
          message: "Expected array, but was " + (xs === null ? xs : typeof xs)
        };
      }

      for (var _i = 0, xs_1 = xs; _i < xs_1.length; _i++) {
        var x = xs_1[_i];
        var validated = runtype.innerValidate(element, x, visited);

        if (!validated.success) {
          return {
            success: false,
            message: validated.message,
            key: validated.key ? "[" + xs.indexOf(x) + "]." + validated.key : "[" + xs.indexOf(x) + "]"
          };
        }
      }

      return {
        success: true,
        value: xs
      };
    }, {
      tag: 'array',
      isReadonly: isReadonly,
      element: element
    }));
  }

  function Arr(element) {
    return InternalArr(element, false);
  }

  exports.Array = Arr;

  function withExtraModifierFuncs(A) {
    A.asReadonly = asReadonly;
    return A;

    function asReadonly() {
      return InternalArr(A.element, true);
    }
  }
});
var tuple = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  function Tuple() {
    var components = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      components[_i] = arguments[_i];
    }

    return runtype.create(function (x, visited) {
      var validated = runtype.innerValidate(array.Array(unknown.Unknown), x, visited);

      if (!validated.success) {
        return {
          success: false,
          message: "Expected tuple to be an array:\xA0" + validated.message,
          key: validated.key
        };
      }

      if (validated.value.length !== components.length) {
        return {
          success: false,
          message: "Expected an array of length " + components.length + ", but was " + validated.value.length
        };
      }

      for (var i = 0; i < components.length; i++) {
        var validatedComponent = runtype.innerValidate(components[i], validated.value[i], visited);

        if (!validatedComponent.success) {
          return {
            success: false,
            message: validatedComponent.message,
            key: validatedComponent.key ? "[" + i + "]." + validatedComponent.key : "[" + i + "]"
          };
        }
      }

      return {
        success: true,
        value: x
      };
    }, {
      tag: 'tuple',
      components: components
    });
  }

  exports.Tuple = Tuple;
});
var util = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  }); // Type guard to determine if an object has a given key
  // If this feature gets implemented, we can use `in` instead: https://github.com/Microsoft/TypeScript/issues/10485

  function hasKey(k, o) {
    return typeof o === 'object' && k in o;
  }

  exports.hasKey = hasKey;
});
var record = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  /**
   * Construct a record runtype from runtypes for its values.
   */

  function InternalRecord(fields, isPartial, isReadonly) {
    return withExtraModifierFuncs(runtype.create(function (x, visited) {
      if (x === null || x === undefined) {
        var a = runtype.create(function (_x) {
          return {
            success: true,
            value: _x
          };
        }, {
          tag: 'record',
          fields: fields
        });
        return {
          success: false,
          message: "Expected " + show_1.default(a) + ", but was " + x
        };
      }

      for (var key in fields) {
        if (!isPartial || util.hasKey(key, x) && x[key] !== undefined) {
          var value = isPartial || util.hasKey(key, x) ? x[key] : undefined;
          var validated = runtype.innerValidate(fields[key], value, visited);

          if (!validated.success) {
            return {
              success: false,
              message: validated.message,
              key: validated.key ? key + "." + validated.key : key
            };
          }
        }
      }

      return {
        success: true,
        value: x
      };
    }, {
      tag: 'record',
      isPartial: isPartial,
      isReadonly: isReadonly,
      fields: fields
    }));
  }

  exports.InternalRecord = InternalRecord;

  function Record(fields) {
    return InternalRecord(fields, false, false);
  }

  exports.Record = Record;

  function Partial(fields) {
    return InternalRecord(fields, true, false);
  }

  exports.Partial = Partial;

  function withExtraModifierFuncs(A) {
    A.asPartial = asPartial;
    A.asReadonly = asReadonly;
    return A;

    function asPartial() {
      return InternalRecord(A.fields, true, A.isReadonly);
    }

    function asReadonly() {
      return InternalRecord(A.fields, A.isPartial, true);
    }
  }
});
var dictionary = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  function Dictionary(value, key) {
    if (key === void 0) {
      key = 'string';
    }

    return runtype.create(function (x, visited) {
      if (x === null || x === undefined) {
        var a = runtype.create(x, {
          tag: 'dictionary',
          key: key,
          value: value
        });
        return {
          success: false,
          message: "Expected " + show_1.default(a) + ", but was " + x
        };
      }

      if (typeof x !== 'object') {
        var a = runtype.create(x, {
          tag: 'dictionary',
          key: key,
          value: value
        });
        return {
          success: false,
          message: "Expected " + show_1.default(a.reflect) + ", but was " + typeof x
        };
      }

      if (Object.getPrototypeOf(x) !== Object.prototype) {
        if (!Array.isArray(x)) {
          var a = runtype.create(x, {
            tag: 'dictionary',
            key: key,
            value: value
          });
          return {
            success: false,
            message: "Expected " + show_1.default(a.reflect) + ", but was " + Object.getPrototypeOf(x)
          };
        } else if (key === 'string') return {
          success: false,
          message: 'Expected dictionary, but was array'
        };
      }

      for (var k in x) {
        // Object keys are unknown strings
        if (key === 'number') {
          if (isNaN(+k)) return {
            success: false,
            message: 'Expected dictionary key to be a number, but was string'
          };
        }

        var validated = runtype.innerValidate(value, x[k], visited);

        if (!validated.success) {
          return {
            success: false,
            message: validated.message,
            key: validated.key ? k + "." + validated.key : k
          };
        }
      }

      return {
        success: true,
        value: x
      };
    }, {
      tag: 'dictionary',
      key: key,
      value: value
    });
  }

  exports.Dictionary = Dictionary;
});
var union = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  function Union() {
    var alternatives = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      alternatives[_i] = arguments[_i];
    }

    var match = function match() {
      var cases = [];

      for (var _i = 0; _i < arguments.length; _i++) {
        cases[_i] = arguments[_i];
      }

      return function (x) {
        for (var i = 0; i < alternatives.length; i++) {
          if (alternatives[i].guard(x)) {
            return cases[i](x);
          }
        }
      };
    };

    return runtype.create(function (value, visited) {
      var commonLiteralFields = {};

      for (var _i = 0, alternatives_1 = alternatives; _i < alternatives_1.length; _i++) {
        var alternative = alternatives_1[_i];

        if (alternative.reflect.tag === 'record') {
          var _loop_1 = function _loop_1(fieldName) {
            var field = alternative.reflect.fields[fieldName];

            if (field.tag === 'literal') {
              if (commonLiteralFields[fieldName]) {
                if (commonLiteralFields[fieldName].every(function (value) {
                  return value !== field.value;
                })) {
                  commonLiteralFields[fieldName].push(field.value);
                }
              } else {
                commonLiteralFields[fieldName] = [field.value];
              }
            }
          };

          for (var fieldName in alternative.reflect.fields) {
            _loop_1(fieldName);
          }
        }
      }

      for (var fieldName in commonLiteralFields) {
        if (commonLiteralFields[fieldName].length === alternatives.length) {
          for (var _a = 0, alternatives_2 = alternatives; _a < alternatives_2.length; _a++) {
            var alternative = alternatives_2[_a];

            if (alternative.reflect.tag === 'record') {
              var field = alternative.reflect.fields[fieldName];

              if (field.tag === 'literal' && util.hasKey(fieldName, value) && value[fieldName] === field.value) {
                return runtype.innerValidate(alternative, value, visited);
              }
            }
          }
        }
      }

      for (var _b = 0, alternatives_3 = alternatives; _b < alternatives_3.length; _b++) {
        var targetType = alternatives_3[_b];

        if (runtype.innerValidate(targetType, value, visited).success) {
          return {
            success: true,
            value: value
          };
        }
      }

      var a = runtype.create(value, {
        tag: 'union',
        alternatives: alternatives
      });
      return {
        success: false,
        message: "Expected " + show_1.default(a) + ", but was " + (value === null ? value : typeof value)
      };
    }, {
      tag: 'union',
      alternatives: alternatives,
      match: match
    });
  }

  exports.Union = Union;
});
var intersect = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  function Intersect() {
    var intersectees = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      intersectees[_i] = arguments[_i];
    }

    return runtype.create(function (value, visited) {
      for (var _i = 0, intersectees_1 = intersectees; _i < intersectees_1.length; _i++) {
        var targetType = intersectees_1[_i];
        var validated = runtype.innerValidate(targetType, value, visited);

        if (!validated.success) {
          return validated;
        }
      }

      return {
        success: true,
        value: value
      };
    }, {
      tag: 'intersect',
      intersectees: intersectees
    });
  }

  exports.Intersect = Intersect;
});

var _function = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  /**
   * Construct a runtype for functions.
   */

  exports.Function = runtype.create(function (value) {
    return typeof value === 'function' ? {
      success: true,
      value: value
    } : {
      success: false,
      message: "Expected function, but was " + (value === null ? value : typeof value)
    };
  }, {
    tag: 'function'
  });
});

var _instanceof = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  function InstanceOf(ctor) {
    return runtype.create(function (value) {
      return value instanceof ctor ? {
        success: true,
        value: value
      } : {
        success: false,
        message: "Expected " + ctor.name + ", but was " + (value === null ? value : typeof value)
      };
    }, {
      tag: 'instanceof',
      ctor: ctor
    });
  }

  exports.InstanceOf = InstanceOf;
});

var lazy = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  /**
   * Construct a possibly-recursive Runtype.
   */

  function Lazy(delayed) {
    var data = {
      get tag() {
        return getWrapped()['tag'];
      }

    };
    var cached;

    function getWrapped() {
      if (!cached) {
        cached = delayed();

        for (var k in cached) {
          if (k !== 'tag') data[k] = cached[k];
        }
      }

      return cached;
    }

    return runtype.create(function (x) {
      return getWrapped().validate(x);
    }, data);
  }

  exports.Lazy = Lazy;
});
var constraint = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  function Constraint(underlying, constraint, options) {
    return runtype.create(function (value) {
      var name = options && options.name;
      var validated = underlying.validate(value);

      if (!validated.success) {
        return validated;
      }

      var result = constraint(validated.value);
      if (string.String.guard(result)) return {
        success: false,
        message: result
      };else if (!result) return {
        success: false,
        message: "Failed " + (name || 'constraint') + " check"
      };
      return {
        success: true,
        value: validated.value
      };
    }, {
      tag: 'constraint',
      underlying: underlying,
      constraint: constraint,
      name: options && options.name,
      args: options && options.args
    });
  }

  exports.Constraint = Constraint;

  exports.Guard = function (guard, options) {
    return unknown.Unknown.withGuard(guard, options);
  };
});
var brand = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.RuntypeName = Symbol('RuntypeName');

  function Brand(brand, entity) {
    return runtype.create(function (value) {
      var validated = entity.validate(value);
      return validated.success ? {
        success: true,
        value: validated.value
      } : validated;
    }, {
      tag: 'brand',
      brand: brand,
      entity: entity
    });
  }

  exports.Brand = Brand;
});
var decorator = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var prototypes = new WeakMap();
  /**
   * A parameter decorator. Explicitly mark the parameter as checked on every method call in combination with `@checked` method decorator. The number of `@check` params must be the same as the number of provided runtypes into `@checked`.\
   * Usage:
   * ```ts
   * @checked(Runtype1, Runtype3)
   * method(@check p1: Static1, p2: number, @check p3: Static3) { ... }
   * ```
   */

  function check(target, propertyKey, parameterIndex) {
    var prototype = prototypes.get(target) || new Map();
    prototypes.set(target, prototype);
    var validParameterIndices = prototype.get(propertyKey) || [];
    prototype.set(propertyKey, validParameterIndices);
    validParameterIndices.push(parameterIndex);
  }

  exports.check = check;

  function getValidParameterIndices(target, propertyKey, runtypeCount) {
    var prototype = prototypes.get(target);
    var validParameterIndices = prototype && prototype.get(propertyKey);

    if (validParameterIndices) {
      // used with `@check` parameter decorator
      return validParameterIndices;
    }

    var indices = [];

    for (var i = 0; i < runtypeCount; i++) {
      indices.push(i);
    }

    return indices;
  }
  /**
   * A method decorator. Takes runtypes as arguments which correspond to the ones of the actual method.
   *
   * Usually, the number of provided runtypes must be _**the same as**_ or _**less than**_ the actual parameters.
   *
   * If you explicitly mark which parameter shall be checked using `@check` parameter decorator, the number of `@check` parameters must be _**the same as**_ the runtypes provided into `@checked`.
   *
   * Usage:
   * ```ts
   * @checked(Runtype1, Runtype2)
   * method1(param1: Static1, param2: Static2, param3: any) {
   *   ...
   * }
   *
   * @checked(Runtype1, Runtype3)
   * method2(@check param1: Static1, param2: any, @check param3: Static3) {
   *   ...
   * }
   * ```
   */


  function checked() {
    var runtypes = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      runtypes[_i] = arguments[_i];
    }

    if (runtypes.length === 0) {
      throw new Error('No runtype provided to `@checked`. Please remove the decorator.');
    }

    return function (target, propertyKey, descriptor) {
      var method = descriptor.value;
      var methodId = (target.name || target.constructor.name + '.prototype') + (typeof propertyKey === 'string' ? "[\"" + propertyKey + "\"]" : "[" + String(propertyKey) + "]");
      var validParameterIndices = getValidParameterIndices(target, propertyKey, runtypes.length);

      if (validParameterIndices.length !== runtypes.length) {
        throw new Error('Number of `@checked` runtypes and @check parameters not matched.');
      }

      if (validParameterIndices.length > method.length) {
        throw new Error('Number of `@checked` runtypes exceeds actual parameter length.');
      }

      descriptor.value = function () {
        var args = [];

        for (var _i = 0; _i < arguments.length; _i++) {
          args[_i] = arguments[_i];
        }

        runtypes.forEach(function (type, typeIndex) {
          var parameterIndex = validParameterIndices[typeIndex];
          var validated = type.validate(args[parameterIndex]);

          if (!validated.success) {
            throw new errors.ValidationError(methodId + ", argument #" + parameterIndex + ": " + validated.message, validated.key);
          }
        });
        return method.apply(this, args);
      };
    };
  }

  exports.checked = checked;
});
var lib = createCommonjsModule(function (module, exports) {
  function __export(m) {
    for (var p in m) {
      if (!exports.hasOwnProperty(p)) exports[p] = m[p];
    }
  }

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  __export(contract);

  __export(asynccontract);

  __export(match_1);

  __export(errors);

  __export(unknown);

  __export(never);

  __export(_void);

  exports.Literal = literal_1.Literal;
  exports.Undefined = literal_1.Undefined;
  exports.Null = literal_1.Null;

  __export(boolean_1);

  __export(number);

  __export(string);

  __export(symbol);

  __export(array);

  __export(tuple);

  __export(record);

  __export(dictionary);

  __export(union);

  __export(intersect);

  __export(_function);

  exports.InstanceOf = _instanceof.InstanceOf;

  __export(lazy);

  __export(constraint);

  exports.Brand = brand.Brand;

  __export(decorator);
});
var Task = lib.Union(lib.Literal("template"), lib.Literal("snippet"), lib.Literal("compile"), lib.Literal("kompile"), lib.Literal("checkstyle"), lib.Literal("ktlint"), lib.Literal("complexity"), lib.Literal("execute"), lib.Literal("cexecute"));
var FlatSource = lib.Record({
  path: lib.String,
  contents: lib.String
});
var Permission = lib.Record({
  klass: lib.String,
  name: lib.String
}).And(lib.Partial({
  actions: lib.String
}));
var FileType = lib.Union(lib.Literal("JAVA"), lib.Literal("KOTLIN"));
var Location = lib.Record({
  line: lib.Number,
  column: lib.Number
});
var SourceRange = lib.Record({
  start: Location,
  end: Location
}).And(lib.Partial({
  source: lib.String
}));
var SourceLocation = lib.Record({
  source: lib.String,
  line: lib.Number,
  column: lib.Number
});
var Interval = lib.Record({
  start: lib.String.withConstraint(function (s) {
    return Date.parse(s) !== NaN;
  }),
  end: lib.String.withConstraint(function (s) {
    return Date.parse(s) !== NaN;
  })
});
var ServerStatus = lib.Record({
  hosts: lib.Array(lib.String),
  tasks: lib.Array(Task),
  started: lib.String.withConstraint(function (s) {
    return Date.parse(s) !== NaN;
  }),
  hostname: lib.String,
  versions: lib.Record({
    jeed: lib.String,
    server: lib.String,
    compiler: lib.String,
    kompiler: lib.String
  }),
  counts: lib.Record({
    submitted: lib.Number,
    completed: lib.Number,
    saved: lib.Number
  }),
  auth: lib.Record({
    none: lib.Boolean,
    google: lib.Record({
      clientIDs: lib.Array(lib.String)
    }).And(lib.Partial({
      hostedDomain: lib.String
    }))
  }),
  cache: lib.Record({
    inUse: lib.Boolean,
    sizeInMB: lib.Number,
    hits: lib.Number,
    misses: lib.Number,
    hitRate: lib.Number,
    evictionCount: lib.Number,
    averageLoadPenalty: lib.Number
  })
}).And(lib.Partial({
  semester: lib.String,
  lastRequest: lib.String.withConstraint(function (s) {
    return Date.parse(s) !== NaN;
  })
}));
var SnippetArguments = lib.Partial({
  indent: lib.Number,
  fileType: FileType
});
var CompilationArguments = lib.Partial({
  wError: lib.Boolean,
  XLint: lib.String,
  enablePreview: lib.Boolean,
  useCache: lib.Boolean,
  waitForCache: lib.Boolean
});
var KompilationArguments = lib.Partial({
  verbose: lib.Boolean,
  allWarningsAsErrors: lib.Boolean,
  useCache: lib.Boolean,
  waitForCache: lib.Boolean
});
var CheckstyleArguments = lib.Partial({
  sources: lib.Array(lib.String),
  failOnError: lib.Boolean
});
var KtLintArguments = lib.Partial({
  sources: lib.Array(lib.String),
  failOnError: lib.Boolean
});
var ClassLoaderConfiguration = lib.Partial({
  whitelistedClasses: lib.Array(lib.String),
  blacklistedClasses: lib.Array(lib.String),
  unsafeExceptions: lib.Array(lib.String),
  isolatedClasses: lib.Array(lib.String)
});
var SourceExecutionArguments = lib.Partial({
  klass: lib.String,
  method: lib.String,
  timeout: lib.Number,
  permissions: lib.Array(Permission),
  maxExtraThreads: lib.Number,
  maxOutputLines: lib.Number,
  classLoaderConfiguration: ClassLoaderConfiguration,
  dryRun: lib.Boolean,
  waitForShutdown: lib.Boolean
});
var ContainerExecutionArguments = lib.Partial({
  klass: lib.String,
  method: lib.String,
  image: lib.String,
  timeout: lib.Number,
  maxOutputLines: lib.Number,
  containerArguments: lib.String
});
var TaskArguments = lib.Partial({
  snippet: SnippetArguments,
  compilation: CompilationArguments,
  kompilation: KompilationArguments,
  checkstyle: CheckstyleArguments,
  ktlint: KtLintArguments,
  execution: SourceExecutionArguments,
  cexecution: ContainerExecutionArguments
});
var Request = lib.Record({
  tasks: lib.Array(Task),
  label: lib.String
}).And(lib.Partial({
  sources: lib.Array(FlatSource),
  templates: lib.Array(FlatSource),
  snippet: lib.String,
  arguments: TaskArguments,
  authToken: lib.String,
  waitForSave: lib.Boolean,
  requireSave: lib.Boolean
}));
var Snippet = lib.Record({
  sources: lib.Dictionary(lib.String),
  originalSource: lib.String,
  rewrittenSource: lib.String,
  snippetRange: SourceRange,
  wrappedClassName: lib.String,
  looseCodeMethodName: lib.String,
  fileType: FileType
});
var TemplatedSourceResult = lib.Record({
  sources: lib.Dictionary(lib.String),
  originalSources: lib.Dictionary(lib.String)
});
var CompilationMessage = lib.Record({
  kind: lib.String,
  message: lib.String
}).And(lib.Partial({
  location: SourceLocation
}));
var CompiledSourceResult = lib.Record({
  messages: lib.Array(CompilationMessage),
  compiled: lib.String.withConstraint(function (s) {
    return Date.parse(s) !== NaN;
  }),
  interval: Interval,
  compilerName: lib.String,
  cached: lib.Boolean
});
var CheckstyleError = lib.Record({
  severity: lib.String,
  location: SourceLocation,
  message: lib.String
});
var CheckstyleResults = lib.Record({
  errors: lib.Array(CheckstyleError)
});
var KtlintError = lib.Record({
  ruleId: lib.String,
  detail: lib.String,
  location: SourceLocation
});
var KtlintResults = lib.Record({
  errors: lib.Array(KtlintError)
});
var FlatClassComplexity = lib.Record({
  name: lib.String,
  path: lib.String,
  range: SourceRange,
  complexity: lib.Number
});
var FlatMethodComplexity = FlatClassComplexity;
var FlatComplexityResult = lib.Record({
  source: lib.String,
  classes: lib.Array(FlatClassComplexity),
  methods: lib.Array(FlatMethodComplexity)
});
var FlatComplexityResults = lib.Record({
  results: lib.Array(FlatComplexityResult)
});
var ThrownException = lib.Record({
  klass: lib.String,
  stacktrace: lib.String
}).And(lib.Partial({
  message: lib.String
}));
var Console = lib.Union(lib.Literal("STDOUT"), lib.Literal("STDERR"));
var OutputLine = lib.Record({
  console: Console,
  line: lib.String,
  timestamp: lib.String.withConstraint(function (s) {
    return Date.parse(s) !== NaN;
  })
}).And(lib.Partial({
  thread: lib.Number
}));
var PermissionRequest = lib.Record({
  permission: Permission,
  granted: lib.Boolean
});
var SourceTaskResults = lib.Record({
  klass: lib.String,
  method: lib.String,
  timeout: lib.Boolean,
  outputLines: lib.Array(OutputLine),
  permissionRequests: lib.Array(PermissionRequest),
  interval: Interval,
  executionInterval: Interval,
  truncatedLines: lib.Number
}).And(lib.Partial({
  returned: lib.String,
  threw: ThrownException
}));
var ContainerExecutionResults = lib.Record({
  klass: lib.String,
  method: lib.String,
  timeout: lib.Boolean,
  outputLines: lib.Array(OutputLine),
  interval: Interval,
  executionInterval: Interval,
  truncatedLines: lib.Number
}).And(lib.Partial({
  exitcode: lib.Number
}));
var CompletedTasks = lib.Partial({
  snippet: Snippet,
  template: TemplatedSourceResult,
  compilation: CompiledSourceResult,
  kompilation: CompiledSourceResult,
  checkstyle: CheckstyleResults,
  ktlint: KtlintResults,
  complexity: FlatComplexityResults,
  execution: SourceTaskResults,
  cexecution: ContainerExecutionResults
});
var TemplatingError = lib.Record({
  name: lib.String,
  line: lib.Number,
  column: lib.Number,
  message: lib.String
});
var TemplatingFailed = lib.Record({
  errors: lib.Array(TemplatingError)
});
var SnippetTransformationError = lib.Record({
  line: lib.Number,
  column: lib.Number,
  message: lib.String
});
var SnippetTransformationFailed = lib.Record({
  errors: lib.Array(SnippetTransformationError)
});
var CompilationError = lib.Record({
  message: lib.String
}).And(lib.Partial({
  location: SourceLocation
}));
var CompilationFailed = lib.Record({
  errors: lib.Array(CompilationError)
});
var CheckstyleFailed = lib.Record({
  errors: lib.Array(CheckstyleError)
});
var KtlintFailed = lib.Record({
  errors: lib.Array(KtlintError)
});
var SourceError = lib.Record({
  message: lib.String
}).And(lib.Partial({
  location: SourceLocation
}));
var ComplexityFailed = lib.Record({
  errors: lib.Array(SourceError)
});
var ExecutionFailedResult = lib.Partial({
  classNotFound: lib.String,
  methodNotFound: lib.String
});
var FailedTasks = lib.Partial({
  template: TemplatingFailed,
  snippet: SnippetTransformationFailed,
  compilation: CompilationFailed,
  kompilation: CompilationFailed,
  checkstyle: CheckstyleFailed,
  ktlint: KtlintFailed,
  complexity: ComplexityFailed,
  execution: ExecutionFailedResult,
  cexecution: ExecutionFailedResult
});
var Response = lib.Record({
  request: Request,
  status: ServerStatus,
  completed: CompletedTasks,
  completedTasks: lib.Array(Task),
  failed: FailedTasks,
  failedTasks: lib.Array(Task)
}).And(lib.Partial({
  email: lib.String,
  audience: lib.Array(lib.String)
}));

function getOriginalLine(request, line, source) {
  if (request.snippet) {
    return request.snippet.split("\n")[line - 1];
  }

  var _iterator = _createForOfIteratorHelper(request.sources || []),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _step$value = _step.value,
          path = _step$value.path,
          contents = _step$value.contents;

      if (source === path || source === "/".concat(path)) {
        return contents.split("\n")[line - 1];
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  throw new Error("Couldn't find line ".concat(line, " in source ").concat(source));
}

function terminalOutput(response) {
  var _a, _b, _c, _d, _e, _f, _g, _h;

  if (!response) {
    return "";
  }

  var request = response.request;

  if (response.failed.snippet) {
    var output = response.failed.snippet.errors.map(function (_ref) {
      var line = _ref.line,
          column = _ref.column,
          message = _ref.message;
      var originalLine = getOriginalLine(request, line);
      return "Line ".concat(line, ": error: ").concat(message, "\n  ").concat(originalLine ? originalLine + "\n" + new Array(column).join(" ") + "^" : "");
    }).join("\n");
    var errorCount = Object.keys(response.failed.snippet.errors).length;
    return "".concat(output, "\n  ").concat(errorCount, " error").concat(errorCount > 1 ? "s" : "");
  } else if (response.failed.compilation || response.failed.kompilation) {
    var _output = ((_a = response.failed.compilation || response.failed.kompilation) === null || _a === void 0 ? void 0 : _a.errors.filter(function (_ref2) {
      var location = _ref2.location;
      return location !== undefined;
    }).map(function (error) {
      var location = error.location,
          message = error.message;
      var source = location.source,
          line = location.line,
          column = location.column;
      var originalLine = getOriginalLine(request, line, source);
      var firstErrorLine = message.split("\n").slice(0, 1).join();
      var restOfError = message.split("\n").slice(1).filter(function (line) {
        return !(source === "" && line.trim().startsWith("location: class"));
      }).join("\n");
      return "".concat(source === "" ? "Line " : "".concat(source, ":")).concat(line, ": error: ").concat(firstErrorLine, "\n  ").concat(originalLine ? originalLine + "\n" + new Array(column).join(" ") + "^" : "").concat(restOfError ? "\n" + restOfError : "");
    }).join("\n")) || "";

    var _errorCount = Object.keys(((_b = response.failed.compilation || response.failed.kompilation) === null || _b === void 0 ? void 0 : _b.errors) || {}).length;
    return "".concat(_output, "\n  ").concat(_errorCount, " error").concat(_errorCount > 1 ? "s" : "");
  } else if (response.failed.checkstyle) {
    var _output2 = ((_c = response.failed.checkstyle) === null || _c === void 0 ? void 0 : _c.errors.map(function (_ref3) {
      var _ref3$location = _ref3.location,
          source = _ref3$location.source,
          line = _ref3$location.line,
          message = _ref3.message;
      return "".concat(source === "" ? "Line " : "".concat(source, ":")).concat(line, ": checkstyle error: ").concat(message);
    }).join("\n")) || "";

    var _errorCount2 = Object.keys(((_d = response.failed.checkstyle) === null || _d === void 0 ? void 0 : _d.errors) || {}).length;
    return "".concat(_output2, "\n  ").concat(_errorCount2, " error").concat(_errorCount2 > 1 ? "s" : "");
  } else if (response.failed.ktlint) {
    var _output3 = ((_e = response.failed.ktlint) === null || _e === void 0 ? void 0 : _e.errors.map(function (_ref4) {
      var _ref4$location = _ref4.location,
          source = _ref4$location.source,
          line = _ref4$location.line,
          detail = _ref4.detail;
      return "".concat(source === "" ? "Line " : "".concat(source, ":")).concat(line, ": ktlint error: ").concat(detail);
    }).join("\n")) || "";

    var _errorCount3 = Object.keys(((_f = response.failed.ktlint) === null || _f === void 0 ? void 0 : _f.errors) || {}).length;
    return "".concat(_output3, "\n  ").concat(_errorCount3, " error").concat(_errorCount3 > 1 ? "s" : "");
  } else if (response.failed.execution || response.failed.cexecution) {
    var failed = response.failed.execution || response.failed.cexecution;

    if (failed === null || failed === void 0 ? void 0 : failed.classNotFound) {
      return "Error: could not find class ".concat(failed === null || failed === void 0 ? void 0 : failed.classNotFound);
    } else if (failed === null || failed === void 0 ? void 0 : failed.methodNotFound) {
      return "Error: could not find method ".concat(failed === null || failed === void 0 ? void 0 : failed.methodNotFound);
    } else {
      return "Something unexpected went wrong...";
    }
  }

  if (Object.keys(response.failed).length === 0 && (response.completed.execution || response.completed.cexecution)) {
    var completed = response.completed.execution || response.completed.cexecution;

    var _output4 = (completed === null || completed === void 0 ? void 0 : completed.outputLines.map(function (_ref5) {
      var line = _ref5.line;
      return line;
    })) || [];

    if ((_g = response.completed.execution) === null || _g === void 0 ? void 0 : _g.threw) {
      _output4.push((_h = response.completed.execution) === null || _h === void 0 ? void 0 : _h.threw.stacktrace);
    } else if (completed === null || completed === void 0 ? void 0 : completed.timeout) {
      _output4.push("(Program timed out)");
    }

    if ((completed === null || completed === void 0 ? void 0 : completed.truncatedLines) || 0 > 0) {
      _output4.push("(".concat(completed === null || completed === void 0 ? void 0 : completed.truncatedLines, " lines were truncated)"));
    }

    return _output4.join("\n");
  }

  console.error("Nothing failed but no success result either...");
  return "";
} // eslint-disable-next-line @typescript-eslint/no-var-requires


require("es6-promise").polyfill();

require("isomorphic-fetch");

var JeedProvider = function JeedProvider(_ref6) {
  var googleToken = _ref6.googleToken,
      server = _ref6.server,
      children = _ref6.children;

  var _useState = useState(undefined),
      _useState2 = _slicedToArray(_useState, 2),
      status = _useState2[0],
      setStatus = _useState2[1];

  useEffect(function () {
    getStatus(server).then(function (status) {
      return setStatus(status);
    }).catch(function () {
      return setStatus(undefined);
    });
  }, [server]);
  var run = useCallback( /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(request) {
      var validate,
          _args = arguments;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              validate = _args.length > 1 && _args[1] !== undefined ? _args[1] : true;

              if (googleToken) {
                request.authToken = googleToken;
              }

              return _context.abrupt("return", postRequest(server, request, validate).then(function (response) {
                setStatus(response.status);
                return response;
              }).catch(function (err) {
                setStatus(undefined);
                throw err;
              }));

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x2) {
      return _ref7.apply(this, arguments);
    };
  }(), [googleToken, server]);
  return React.createElement(JeedContext.Provider, {
    value: {
      available: true,
      status: status,
      connected: status !== undefined,
      run: run
    }
  }, children);
};

var useJeed = function useJeed() {
  return useContext(JeedContext);
};

function getStatus(_x3) {
  return _getStatus.apply(this, arguments);
}

function _getStatus() {
  _getStatus = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(server) {
    var validate,
        status,
        _args2 = arguments;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            validate = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : true;
            _context2.next = 3;
            return fetch(server);

          case 3:
            _context2.next = 5;
            return _context2.sent.json();

          case 5:
            status = _context2.sent;
            return _context2.abrupt("return", validate ? ServerStatus.check(status) : status);

          case 7:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _getStatus.apply(this, arguments);
}

function postRequest(_x4, _x5) {
  return _postRequest.apply(this, arguments);
}

function _postRequest() {
  _postRequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(server, request) {
    var validate,
        response,
        _args3 = arguments;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            validate = _args3.length > 2 && _args3[2] !== undefined ? _args3[2] : true;
            request = validate ? Request.check(request) : request;
            _context3.next = 4;
            return fetch(server, {
              method: "post",
              body: JSON.stringify(request),
              headers: {
                "Content-Type": "application/json"
              },
              credentials: "include"
            });

          case 4:
            _context3.next = 6;
            return _context3.sent.json();

          case 6:
            response = _context3.sent;
            return _context3.abrupt("return", validate ? Response.check(response) : response);

          case 8:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _postRequest.apply(this, arguments);
}

var JeedContext = React.createContext({
  available: false,
  connected: false,
  status: undefined,
  run: function run() {
    throw new Error("Jeed Context not available");
  }
});
export { CheckstyleArguments, CheckstyleError, CheckstyleFailed, CheckstyleResults, ClassLoaderConfiguration, CompilationArguments, CompilationError, CompilationFailed, CompilationMessage, CompiledSourceResult, CompletedTasks, ComplexityFailed, Console, ExecutionFailedResult, FailedTasks, FileType, FlatClassComplexity, FlatComplexityResult, FlatComplexityResults, FlatMethodComplexity, FlatSource, Interval, JeedContext, JeedProvider, KompilationArguments, KtLintArguments, KtlintError, KtlintFailed, KtlintResults, Location, OutputLine, Permission, PermissionRequest, Request, Response, ServerStatus, Snippet, SnippetArguments, SnippetTransformationError, SnippetTransformationFailed, SourceError, SourceExecutionArguments, SourceLocation, SourceRange, SourceTaskResults, Task, TaskArguments, TemplatedSourceResult, TemplatingError, TemplatingFailed, ThrownException, getOriginalLine, postRequest, terminalOutput, useJeed };